import { render, staticRenderFns } from "./ImportReplacementList.html?vue&type=template&id=62b95fa8&external"
import script from "./ImportReplacementList.ts?vue&type=script&lang=ts&external"
export * from "./ImportReplacementList.ts?vue&type=script&lang=ts&external"
import style0 from "./ImportReplacementList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports